<template>
  <div class="buyerManage">
    <!-- 搜索 -->
    <!-- <div class="search_bar">
      <van-search
        v-model="listQuery.name"
        show-action
        placeholder="请输入买家姓名进行搜索"
        @search="onSearch"
      >
        <template slot="action">
          <div @click="onSearch">搜 索</div>
        </template>
      </van-search>
    </div> -->
    <div class="content">
      <van-index-bar :index-list="list_index" :sticky="false" highlight-color="#2c3e50">
        <van-index-anchor v-for="(item,index) in list" :key="index" :index="index">
          <span>{{index}}</span>
          <van-cell
            v-for="(citem,cindex) in item"
            :key="cindex"
            v-show="!(isCredit==1&&citem.id==1)"
            :disabled="citem.status == 0"
            :value="citem.status == 0?'已停用':citem.mobile"
            @click="use_type == 1?(citem.status == 1?backPage(citem):''):toDetail(citem)"
          >
            <template #title>
              <div class="van-ellipsis" style="width:3.7rem;font-weight:bold;">
                {{citem.name}}
              </div>
            </template>
          </van-cell>
        </van-index-anchor>
      </van-index-bar>
    </div>
    <div class="add-btn" @click="$router.push('/manage/buyer/addBuyer')">添加买家</div>
  </div>
</template>

<script>
import { buyer_list } from "@/api/work/manage/buyer";
export default {
  name: "buyerManage",
  data() {
    return {
      list:{},
      list_index:[],

      listQuery: {
        page: 1,
        pageSize: "1500",
        name: "",
        status:""
      },

      use_type:1,
      isCredit:0
    };
  },
  beforeRouteEnter (to, from, next) {
    if(to.query.use_type == 1){
      to.meta.title = '选择买家'
    }else{
      to.meta.title = '买家管理'
    }
    next()
  },
  created() {
    if(this.$route.meta.backData){
      delete this.$route.meta.backData
    }
    // 判断是不是 调用的
    this.isCredit = this.$route.query.isCredit || 0
    if(this.$route.query.use_type == 1){
      this.use_type = 1
      this.listQuery.status = "1"
    }else{
      this.use_type = 0
      this.listQuery.status = ''
    }
    this.getList()
    
    this.$navigation.on('back', (to, from) => {
      if(from.route.name == 'manage_buyer_addBuyer' || from.route.name == 'manage_buyer_buyerDetail'){
        this.getList()
      }
    })
  },
  mounted() {},
  methods: {
    
    // 点击了搜索按钮
    onSearch(){
      this.getList()
    },

    // 获取列表
    getList() {
      buyer_list(this.listQuery).then(res => {
        if (res.code == 200) {
          if(res.data.list["#"] && res.data.list["#"].length == 1 && this.isCredit == 1){
            delete res.data.list["#"]
          }
          this.list = res.data.list
          this.list_index = []
          for (const key in res.data.list) {
            this.list_index.push(key)
          }
        }
      });
    },

    // 去买家详情
    toDetail(item){
      this.$router.push({
        path:'/manage/buyer/buyerDetail',
        query:{
          id:item.id
        }
      })
    },


    // 返回上一页
    backPage(item){
      this.$route.meta.backData = item
      this.$router.go(-1)
    }
  }
  
};
</script>

<style lang="less" scoped>
.buyerManage {
    height: calc(100vh - 0.88rem); 
    overflow-y: auto;
  .search_bar {
    position: sticky;
    top: 0.88rem;
    z-index: 2;
    box-shadow: 0 0 0.05rem 0.05rem #f1f1f1;
  }
  .content {
    padding-bottom: 1.2rem;
  }
  .add-btn {
    width: 100%;
    line-height: 1rem;
    background-color: #31b158;
    color: #fff;
    font-size: 0.36rem;
    text-align: center;
    position: fixed;
    bottom: 0;
  }
}
</style>